module.exports = __webpack_public_path__ + "img/img3_m.445b69e7.png";